import React, {Component} from 'react';
import PropTypes from 'prop-types';
// import Icon from '@ant-design/icons'
import BaseComponent from '../../../../../base/BaseComponent';
import {Icon, Tooltip} from "antd";
import {DownLoad} from "../img/svg.js"
import {Checkbox} from 'antd';
import Titlepicfile from "../../../../components/titlepicfile/Titlepicfile";
import {unitConvert} from "../../../../../utils";
import lock from "../../resourcePool/img/lock.png";

const DownLoadIcon = props => <Icon type="arrow-down" />
export default class Picture extends BaseComponent {
    static defaultProps = {
        checked: false,
        name: 'tttppp',
        size: '2.2M',
        pixel: '1920 x 1060',
        img: 'images/folder.png',
        onClick: () => {
            console.log("点击");
        },
        IsChecked:()=>{

        },
        onDownloadCall:()=>{},
        file:{}
    };
    
    static propTypes = {
        name: PropTypes.string.isRequired,//传入dom 结构
        size: PropTypes.string.isRequired,//文件大小
        pixel:PropTypes.string.isRequired,//图片像素
        onClick: PropTypes.func.isRequired,//点击函数
        IsChecked: PropTypes.func.isRequired,//选中的函数
        img:PropTypes.string.isRequired,//传入图标
        downloadImg:PropTypes.string,//下载的图标
        download:PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            picDown:""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }

    download(md5) {
        if (typeof this.props.onDownloadCall == "function") {
            this.props.onDownloadCall(md5)
        }
    }

    render() {
        // 鼠标划过
        let isHover,show;
        if(this.props.checked){
            isHover ='block';
            if(this.state.hover){
                show='block'
            }else{
                show='none'
            }
        }else{
            isHover ='none';
            if(this.state.hover){
                isHover ='block';
                 show='block'
            }else{
                isHover ='none';
                show='none'
            }
        }
        return(
            <div>
                {this.renderFileCard(isHover,show)}
            </div>)
    }
    renderFileCard(isHover,show) {
        let size = this.props.file['size'];
        return (
            <div style={{width: '176px',}}
                 onMouseOver ={() => this.handleEnter()}
                 onMouseOut= {() => this.handleOut()}

            >
                <div style={{width: '176px', height: '99px', marginBottom: '8px', position: "relative",cursor: "pointer"}}>
                    <div onClick={() => {this.props.onClick()}}>
                        <Titlepicfile style={{width: '176px', height: '99px'}} src={this.props.file['icon']}/>
                    </div>
                    {this.props.IsDownLoad?<div style={{width: '176px', height: '99px', marginBottom: '8px',zIndex:9 , position: "absolute",top:0,left:0,background: 'rgba(0,0,0,0.2600)'}} onClick={()=>{
                        this.props.applyDownload&&this.props.applyDownload()
                    }}></div>:null}
                    {this.props.IsDownLoad? <img src={lock}  style={{
                        position:'absolute',
                        top:5,
                        left:7,
                        zIndex:10,
                        fontSize:'16px',
                        color:'#ffffff'}}  onClick={()=>{
                        this.props.applyDownload&&this.props.applyDownload()
                    }}/>:null}
                     {/*显示隐藏*/}
                    <div style={{
                        display:show,
                        width: '176px',
                        height: '20px',
                        position: 'absolute',
                        bottom: '0',
                        background: 'rgba(0, 0, 0, 0.4)',
                        fontSize: '10px',
                        zIndex:1
                    }}
                    >
                        <p style={{
                            marginLeft: '8px',
                            float: 'left',
                            color: 'rgba(255, 255, 255, 1)'
                        }}>{this.props.file['width']} x {this.props.file['height']}</p>

                        {/*{this.props.IsDownLoad?<Icon type="lock" style={{position:'absolute',right:10,bottom:10}}/>:null}*/}
                        <Icon type="arrow-down"  style={{marginRight: '8px',float: 'right',width: '16px',height: '16px',marginTop: '2px',fontSize:'15px',color:'white',fontWeight:'500'}}  onClick={() => {this.download(this.props.file.md5)}}/>
                        {/*<DownLoadIcon style={{marginRight: '8px',float: 'right',width: '16px',height: '16px',marginTop: '2px'}}*/}
                        {/*              onClick={() => {this.download(this.props.file.md5)}}/>*/}
                    </div>
                    <div style={{width:35,height:35,display: isHover, position: 'absolute', right: 0, top: 0,zIndex:10,cursor: "pointer"}}
                         onClick={() => {
                             this.props.IsChecked && this.props.IsChecked(!this.props.checked)
                         }}>
                        <Checkbox checked={this.props.checked} style={{marginLeft:10,marginTop:5}} onChange={(e)=>{
                            // this.props.IsChecked && this.props.IsChecked(e)
                        }}>
                        </Checkbox>
                    </div>
                </div>
                <div style={{height: "36px", textAlign: 'center', lineHeight: '18px'}}>
                        <div  className={'twoText'} style={{fontSize: '14px',overflow: 'hidden',textOverflow:'ellipsis', color: "rgba(0, 0, 0, 0.65)"}}  title={this.props.file['name'] || ""}>{this.props.file['name'] || ""}</div>
                    <div style={{fontSize: '12px', color: "rgba(0, 0, 0, 0.45"}}>{size?unitConvert(size):'0B'}</div>
                </div>
            </div>
        )
    }



}
